/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Free_CtaInputs */

const en_pricing_free_cta = /** @type {(inputs: Pricing_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Free`)
};

const es_pricing_free_cta = /** @type {(inputs: Pricing_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar gratis`)
};

const fr_pricing_free_cta = /** @type {(inputs: Pricing_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer gratuitement`)
};

const de_pricing_free_cta = /** @type {(inputs: Pricing_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos starten`)
};

const ja_pricing_free_cta = /** @type {(inputs: Pricing_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料で始める`)
};

const zh_pricing_free_cta = /** @type {(inputs: Pricing_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开始`)
};

const ar_pricing_free_cta = /** @type {(inputs: Pricing_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ مجانًا`)
};

const id_pricing_free_cta = /** @type {(inputs: Pricing_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai Gratis`)
};

const it_pricing_free_cta = /** @type {(inputs: Pricing_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia Gratis`)
};

const ru_pricing_free_cta = /** @type {(inputs: Pricing_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать бесплатно`)
};

const pt_pricing_free_cta = /** @type {(inputs: Pricing_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar Grátis`)
};

const ko_pricing_free_cta = /** @type {(inputs: Pricing_Free_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료로 시작하기`)
};

/**
* | output |
* | --- |
* | "Start Free" |
*
* @param {Pricing_Free_CtaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_free_cta = /** @type {((inputs?: Pricing_Free_CtaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Free_CtaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_free_cta(inputs)
	if (locale === "es") return es_pricing_free_cta(inputs)
	if (locale === "fr") return fr_pricing_free_cta(inputs)
	if (locale === "de") return de_pricing_free_cta(inputs)
	if (locale === "ja") return ja_pricing_free_cta(inputs)
	if (locale === "zh") return zh_pricing_free_cta(inputs)
	if (locale === "ar") return ar_pricing_free_cta(inputs)
	if (locale === "id") return id_pricing_free_cta(inputs)
	if (locale === "it") return it_pricing_free_cta(inputs)
	if (locale === "ru") return ru_pricing_free_cta(inputs)
	if (locale === "pt") return pt_pricing_free_cta(inputs)
	return ko_pricing_free_cta(inputs)
});